module.exports = __webpack_public_path__ + "img/img.ba829c30.jpg";